import { render, staticRenderFns } from "./signAuth.vue?vue&type=template&id=4ccd3762&scoped=true"
import script from "./signAuth.vue?vue&type=script&lang=js"
export * from "./signAuth.vue?vue&type=script&lang=js"
import style0 from "./signAuth.vue?vue&type=style&index=0&id=4ccd3762&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccd3762",
  null
  
)

export default component.exports